import { useState, useEffect } from 'react';
import ConfirmDialog from 'src/components/common/ConfirmDialog';
import { Input } from 'src/components/ui/input';
import { T, useGT, Var } from 'gt-react';

const DELETE_CONFIRMATION_TEXT = 'delete';

interface DeleteAgreementConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  agreementName: string | undefined;
  loading: boolean;
}

export function DeleteAgreementConfirmDialog({
  open,
  onClose,
  onConfirm,
  agreementName,
  loading,
}: DeleteAgreementConfirmDialogProps) {
  const gt = useGT();
  const [deleteConfirmationName, setDeleteConfirmationName] = useState('');

  // Reset confirmation text when dialog opens
  useEffect(() => {
    if (open) {
      setDeleteConfirmationName('');
    }
  }, [open]);

  const isConfirmDisabled = deleteConfirmationName !== DELETE_CONFIRMATION_TEXT;

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={gt('Delete Rebate Agreement', {
        context:
          'title for the confirmation dialog when deleting a rebate agreement',
      })}
      message={`Are you sure you want to delete "${agreementName}"? This will permanently delete the agreement and ALL associated data including rebate rules, product groups, supplier payments, invoices, and documents.`}
      confirmText="Delete Agreement"
      loading={loading}
      dangerous={!isConfirmDisabled}
      disabled={isConfirmDisabled}
    >
      <div className="-mt-4 space-y-4">
        <label className="text-sm font-normal text-gray-700">
          <T context="instruction text in delete rebate agreement dialog, warning user to type a confirmation word">
            This action cannot be undone. Type{' '}
            <b>
              <Var>{DELETE_CONFIRMATION_TEXT}</Var>
            </b>{' '}
            to confirm.
          </T>
        </label>
        <Input
          type="text"
          value={deleteConfirmationName}
          onChange={(e) => setDeleteConfirmationName(e.target.value)}
          placeholder={`Type '${DELETE_CONFIRMATION_TEXT}' to confirm`}
          className="w-full mt-2"
          autoFocus
        />
      </div>
    </ConfirmDialog>
  );
}
